/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

export enum DisplayType {
	DISPLAY_TYPE_NONE = 'DISPLAY_TYPE_NONE',
	DISPLAY_TYPE_LOADING = 'DISPLAY_TYPE_LOADING',
	DISPLAY_TYPE_VERIFIED = 'DISPLAY_TYPE_VERIFIED',
	DISPLAY_TYPE_OUTDATED = 'DISPLAY_TYPE_OUTDATED'
}
